import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { GetDeleteQualification, GetQualification } from "./thunk";
import { IQualificationInitialState } from "../types";
import { IEntityWithIDTranslations } from "../../../../types";

const initialState: IQualificationInitialState = {
    qualificationData: [],
    selectedQualificationIDs: [],
    filteredQualification: [],
    isLoadingQualification: false,
    qualificationRestoreData: [],
    isViewQualificationRestore: false,
};

const qualificationSlice = createSlice({
    name: "qualification",
    initialState,
    reducers: {
        setQualificationData: (
            state,
            action: PayloadAction<{ data: IEntityWithIDTranslations[]; defaultLanguage: string }>
        ) => {
            const { data, defaultLanguage } = action.payload;
            state.qualificationData = data;

            state.filteredQualification = state.qualificationData.flatMap(data => {
                return data.translations
                    .filter(elem => elem.slug === defaultLanguage)
                    .map(elem => ({
                        id: data.id,
                        name: elem.name || "Unknown Name",
                    }));
            });
        },
        deletedQualification: (state, action: PayloadAction<number>) => {
            state.qualificationData = state.qualificationData.filter(elem => elem.id !== action.payload);
        },
        updateQualifications: (state, action: PayloadAction<IEntityWithIDTranslations>) => {
            const updateData = action.payload;

            state.qualificationData = state.qualificationData.map(elem => {
                if (elem.id === updateData.id) {
                    return {
                        ...elem,
                        ...updateData,
                    };
                }
                return elem;
            });
        },
        setQualificationRestoreData: (state, action) => {
            state.qualificationRestoreData = action.payload;
        },
        setIsViewQualificationRestore: state => {
            state.isViewQualificationRestore = !state.isViewQualificationRestore;
        },
        deletedRestoreQualification: (state, action) => {
            state.qualificationRestoreData = state.qualificationRestoreData.filter(elem => elem.id !== action.payload);
        },
        setSelectedQualificationIDs: (state, action) => {
            state.selectedQualificationIDs = action.payload;
        },
    },
    extraReducers: builder => {
        builder
            .addCase(GetQualification.pending, state => {
                state.isLoadingQualification = true;
            })
            .addCase(GetQualification.fulfilled, state => {
                state.isLoadingQualification = false;
            })
            .addCase(GetQualification.rejected, state => {
                state.isLoadingQualification = false;
            })
            .addCase(GetDeleteQualification.pending, state => {
                state.isLoadingQualification = true;
            })
            .addCase(GetDeleteQualification.fulfilled, state => {
                state.isLoadingQualification = false;
            })
            .addCase(GetDeleteQualification.rejected, state => {
                state.isLoadingQualification = false;
            });
    },
});

export const {
    setQualificationData,
    deletedQualification,
    updateQualifications,

    setSelectedQualificationIDs,
    setIsViewQualificationRestore,
    deletedRestoreQualification,
    setQualificationRestoreData,
} = qualificationSlice.actions;
export default qualificationSlice;
